import { Button as MUIButton, CircularProgress, Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { cn, stripDefaultTextColorIfCustomExists } from '@src/utils/ui';

const defaultClassname = 'tw-rounded-none';

const CLASSES = {
    contained:
        'tw-text-[16px] tw-rounded-none tw-bg-primary-500 hover:tw-bg-primary-600 hover:tw-text-white focus:tw-text-white',
    outlined: 'tw-text-[16px] tw-rounded-none tw-border-primary-500 tw-text-primary-500 hover:tw-border-primary-600',
    text: 'tw-text-[16px] tw-rounded-none tw-text-primary-500'
};

export const Button = ({ children, className, variant = 'text', loading, component, onClick, ...rest }) => {
    const variantClassName = stripDefaultTextColorIfCustomExists(CLASSES[variant] || defaultClassname, className);

    return (
        <MUIButton
            component={component || 'button'}
            variant={variant}
            className={cn(
                rest.color === 'error' && 'tw-border-solid tw-border-[1px] tw-font-[500]',
                variantClassName,
                className
            )}
            disableElevation
            disabled={rest.disabled}
            onClick={loading ? null : onClick}
            {...rest}
            sx={{
                position: 'relative',
                ...rest.sx
            }}
        >
            <Box sx={{ opacity: loading ? 0 : 1 }}>{children}</Box>

            {/* Remove this if we upgrade to MUI 6 and above along with the box above */}
            {loading && (
                <CircularProgress
                    size={20}
                    color='inherit'
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-10px',
                        marginLeft: '-10px'
                    }}
                />
            )}
        </MUIButton>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    component: PropTypes.string,
    variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
    loading: PropTypes.bool,
    onClick: PropTypes.func
};
